import React, { useContext } from 'react'
import { Redirect, Route, RouteProps } from 'react-router'
import { UserContext } from '../../contexts/UserContext'
import useUser from '../../contexts/hooks/useUser'

interface ProtectedRouteProps extends RouteProps {
	component: React.ComponentType<any>
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
	const { user } = useUser()

	const { skipLogin } = useContext(UserContext)

	const isAuthenticated = !!user || skipLogin

	return (
		<Route
			{...rest}
			render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to='/' />)}
		/>
	)
}
export default ProtectedRoute
